import React from 'react';
import './SchoolImage.css';
import { PATH } from '../../../../constants';

// todo - almost identical to article image - maybe can be stacked together

const getImage = (sheetId, imageName) => (
  <img
    src={`${PATH.SCHOOL}img/${sheetId}/${imageName}.jpg`}
    alt="Ilustrační obrázek"
  />
);

const SchoolImage = ({ sheetId, sectionData }) => (
  <div className="part image">
    {sectionData.full &&
    <a className="zoom-link" href={`${PATH.SCHOOL}img/${sheetId}/${sectionData.name}-full.jpg`} target="_blank">
      {getImage(sheetId, sectionData.name)}
      <img
        className="ico-zoom"
        src={`${PATH.IMG}ico/ico-zoom.png`}
        alt=""
      />
    </a>
    }
    {!sectionData.full &&
    getImage(sheetId, sectionData.name)
    }
    {sectionData.source.length > 0 &&
    <div
      className="note"
      dangerouslySetInnerHTML={{ __html: sectionData.source }}
    />
    }
  </div>
);

export default SchoolImage;




// WEBPACK FOOTER //
// ./src/components/App/SchoolDetail/SchoolImage/SchoolImage.js